import { baseApi as api } from 'shared/api/baseApi';
const injectedRtkApi = api.injectEndpoints({
	endpoints: (build) => ({
		accountLanguageCreate: build.mutation<AccountLanguageCreateApiResponse, AccountLanguageCreateApiArg>({
			query: (queryArg) => ({ url: `/api/account/language/`, method: 'POST', body: queryArg }),
		}),
		accountPortfolioitemsList: build.query<AccountPortfolioitemsListApiResponse, AccountPortfolioitemsListApiArg>({
			query: (queryArg) => ({
				url: `/api/account/portfolioitems/`,
				params: {
					limit: queryArg.limit,
					offset: queryArg.offset,
					ordering: queryArg.ordering,
				},
			}),
		}),
		// Don't change this endpoints
		accountPortfolioitemsCreate: build.mutation<AccountPortfolioitemsCreateApiResponse, FormData>({
			query: (formData) => ({ url: `/api/account/portfolioitems/`, method: 'POST', body: formData }),
		}),
		accountPortfolioitemsRetrieve: build.query<
			AccountPortfolioitemsRetrieveApiResponse,
			AccountPortfolioitemsRetrieveApiArg
		>({
			query: (queryArg) => ({ url: `/api/account/portfolioitems/${queryArg}/` }),
		}),
		accountPortfolioitemsUpdate: build.mutation<
			AccountPortfolioitemsUpdateApiResponse,
			AccountPortfolioitemsUpdateApiArg
		>({
			query: (queryArg) => ({
				url: `/api/account/portfolioitems/${queryArg.id}/`,
				method: 'PUT',
				body: queryArg.portfolioItemUpdateValidatorRequest,
			}),
		}),
		accountPortfolioitemsPartialUpdate: build.mutation<
			AccountPortfolioitemsPartialUpdateApiResponse,
			AccountPortfolioitemsPartialUpdateApiArg
		>({
			query: (queryArg) => ({
				url: `/api/account/portfolioitems/${queryArg.id}/`,
				method: 'PATCH',
				body: queryArg.patchedPortfolioItemUpdateValidatorRequest,
			}),
		}),
		accountPortfolioitemsPreviewsList: build.query<
			AccountPortfolioitemsPreviewsListApiResponse,
			AccountPortfolioitemsPreviewsListApiArg
		>({
			query: (queryArg) => ({
				url: `/api/account/portfolioitems/${queryArg.portfolioitemId}/previews/`,
				params: {
					limit: queryArg.limit,
					offset: queryArg.offset,
				},
			}),
		}),
		accountPortfolioitemsPreviewsCreate: build.mutation<
			AccountPortfolioitemsPreviewsCreateApiResponse,
			AccountPortfolioitemsPreviewsCreateApiArg
		>({
			query: (queryArg) => ({
				url: `/api/account/portfolioitems/${queryArg.portfolioitemId}/previews/`,
				method: 'POST',
				body: queryArg.portfolioItemPreviewCreateRequest,
			}),
		}),
		accountPortfolioitemsPreviewsDestroy: build.mutation<
			AccountPortfolioitemsPreviewsDestroyApiResponse,
			AccountPortfolioitemsPreviewsDestroyApiArg
		>({
			query: (queryArg) => ({
				url: `/api/account/portfolioitems/${queryArg.portfolioitemId}/previews/${queryArg.id}/`,
				method: 'DELETE',
			}),
		}),
		accountProfileRetrieve: build.query<AccountProfileRetrieveApiResponse, AccountProfileRetrieveApiArg>({
			query: () => ({ url: `/api/account/profile/` }),
		}),
		accountProfileCreate: build.mutation<AccountProfileCreateApiResponse, AccountProfileCreateApiArg>({
			query: (queryArg) => ({ url: `/api/account/profile/`, method: 'POST', body: queryArg }),
		}),
		accountSettingsCreate: build.mutation<AccountSettingsCreateApiResponse, AccountSettingsCreateApiArg>({
			query: (queryArg) => ({ url: `/api/account/settings/`, method: 'POST', body: queryArg }),
		}),
	}),
	overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type AccountLanguageCreateApiResponse = unknown;
export type AccountLanguageCreateApiArg = Language;
export type AccountPortfolioitemsListApiResponse = /** status 200  */ PaginatedPortfolioItemListListRead;
export type AccountPortfolioitemsListApiArg = {
	/** Number of results to return per page. */
	limit?: number;
	/** The initial index from which to return the results. */
	offset?: number;
	/** Order results by field. Prefix with '-' for descending order. Available fields: created_at. Default: -created_at */
	ordering?: string;
};
export type AccountPortfolioitemsCreateApiResponse = /** status 201  */ PortfolioItemDetailsRead;
export type AccountPortfolioitemsCreateApiArg = PortfolioItemCreateValidatorRequestWrite;
export type AccountPortfolioitemsRetrieveApiResponse = /** status 200  */ PortfolioItemDetailsRead;
export type AccountPortfolioitemsRetrieveApiArg = string;
export type AccountPortfolioitemsUpdateApiResponse = /** status 200  */ PortfolioItemDetailsRead;
export type AccountPortfolioitemsUpdateApiArg = {
	id: string;
	portfolioItemUpdateValidatorRequest: PortfolioItemUpdateValidatorRequest;
};
export type AccountPortfolioitemsPartialUpdateApiResponse = /** status 200  */ PortfolioItemDetailsRead;
export type AccountPortfolioitemsPartialUpdateApiArg = {
	id: string;
	patchedPortfolioItemUpdateValidatorRequest: PatchedPortfolioItemUpdateValidatorRequest;
};
export type AccountPortfolioitemsPreviewsListApiResponse =
	/** status 200  */ PaginatedPortfolioItemPreviewCreateListRead;
export type AccountPortfolioitemsPreviewsListApiArg = {
	/** Number of results to return per page. */
	limit?: number;
	/** The initial index from which to return the results. */
	offset?: number;
	portfolioitemId: string;
};
export type AccountPortfolioitemsPreviewsCreateApiResponse = /** status 201  */ PortfolioItemPreviewCreateRead;
export type AccountPortfolioitemsPreviewsCreateApiArg = {
	portfolioitemId: string;
	portfolioItemPreviewCreateRequest: PortfolioItemPreviewCreateRequest;
};
export type AccountPortfolioitemsPreviewsDestroyApiResponse = unknown;
export type AccountPortfolioitemsPreviewsDestroyApiArg = {
	id: string;
	portfolioitemId: string;
};
export type AccountProfileRetrieveApiResponse = /** status 200  */ Profile;
export type AccountProfileRetrieveApiArg = void;
export type AccountProfileCreateApiResponse = unknown;
export type AccountProfileCreateApiArg = Messengers;
export type AccountSettingsCreateApiResponse = unknown;
export type AccountSettingsCreateApiArg = AccountSettings;
export type Language = {
	language: LanguageEnum;
};
export type PortfolioItemList = {};
export type PortfolioItemListRead = {
	id: string;
	name: string;
	quantity: string;
	price: string;
	currency: string;
	link: string;
	description: string;
};
export type PaginatedPortfolioItemListList = {
	count: number;
	next?: string | null;
	previous?: string | null;
	results: PortfolioItemList[];
};
export type PaginatedPortfolioItemListListRead = {
	count: number;
	next?: string | null;
	previous?: string | null;
	results: PortfolioItemListRead[];
};
export type PortfolioItemDetails = {};
export type User = {};
export type UserRead = {
	id: string;
	username: string;
	email: string;
};
export type PortfolioItemPreview = {};
export type PortfolioItemPreviewRead = {
	id: string;
	file: string;
	created_at: string;
};
export type PortfolioItemDetailsRead = {
	id: string;
	name: string;
	quantity: string;
	price: string;
	currency: string;
	link: string;
	description: string;
	user: UserRead;
	previews: PortfolioItemPreviewRead[];
	created_at: string;
	updated_at: string;
};
export type PortfolioItemCreateValidatorRequest = {};
export type PortfolioItemCreateValidatorRequestWrite = {
	name: string;
	quantity: string;
	price: string;
	currency: string;
	link: string;
	description: string;
	previews?: Blob[];
};
export type PortfolioItemUpdateValidatorRequest = {
	name: string;
	quantity?: string;
	price: string;
	currency: string;
	link?: string;
	description: string;
};
export type PatchedPortfolioItemUpdateValidatorRequest = {
	name?: string;
	quantity?: string;
	price?: string;
	currency?: string;
	link?: string;
	description?: string;
};
export type PortfolioItemPreviewCreate = {
	file: string;
};
export type PortfolioItemPreviewCreateRead = {
	id: string;
	file: string;
	portfolioitem_id: string;
};
export type PaginatedPortfolioItemPreviewCreateList = {
	count: number;
	next?: string | null;
	previous?: string | null;
	results: PortfolioItemPreviewCreate[];
};
export type PaginatedPortfolioItemPreviewCreateListRead = {
	count: number;
	next?: string | null;
	previous?: string | null;
	results: PortfolioItemPreviewCreateRead[];
};
export type PortfolioItemPreviewCreateRequest = {
	file: Blob;
};
export type AccountManager = {
	first_name: string;
	last_name: string;
	email: string;
};
export type Profile = {
	telegram?: string;
	whatsapp?: string;
	skype?: string;
	account_manager: AccountManager | null;
	currency: string;
	language: string;
};
export type Messengers = {
	telegram?: string;
	whatsapp?: string;
	skype?: string;
};
export type AccountSettings = {
	telegram?: string;
	whatsapp?: string;
	skype?: string;
	currency: string;
	language: LanguageEnum;
};
export enum LanguageEnum {
	En = 'en',
	Ru = 'ru',
	Es = 'es',
}
